<template>
    <div :class="['side', {'closeSide': !showMenu}]">
      <div v-if="showMenu" :class="['side', {'closeSide': closeSide}]">
        <div :class="['left',classObj]">
            <div :class="['title', {'close': showLeft}]">
              <template v-if="!showLeft">
                <p>
                  <span class="menu-icon icon-crowdfunding"></span>
                  <span>发起的</span>项目 {{ proListObj.total }}</p>
                  <div v-if="showMore" class="showDrawer" @click.stop="drawer = true">
                    更多<el-icon :size="14"><ArrowRight /></el-icon>
                  </div>
              </template>
              <p v-else>项目 {{ proListObj.total }}</p>
            </div>
            <div :class="['project_list',{'close':showLeft}]">
              <template v-for="(item, index) in leftProList" :key="index">
                <div v-if="index < 4" :class="['pro_item',{'active': item.temp_id ? pro_id == item.temp_id : pro_id == item.id }]" @click="changePro(item, 'left')">
                <el-tooltip
                  :disabled="!showLeft"
                  effect="dark"
                  :content="item.title || item.name"
                  placement="right"
                >
                  <div :class="[coverClassObj,'cover']">
                    <img :src="item.wb_logo_1 || item.logo || 'https://s.moimg.net/m/img/placeholder/default_1x1@2x.png'" />
                  </div>
                </el-tooltip>
                <p :class="[titleClassObj,'render-line-clamp']">{{item.title || item.name}}</p>
              </div>
              </template>
            </div>
            <div v-if="showLeft && showMore" class="showDrawer showDrawer-bottom" @click.stop="drawer = true">
              更多<el-icon :size="14"><ArrowRight /></el-icon>
            </div>
            <!-- 其余菜单 -->
            <div v-if="showLeft" class="icon_others">
              <template v-for="(item, index) in others" :key="index">
                <el-popover 
                  v-if="item.child && item.child.length" 
                  placement="right" 
                  :width="130" 
                  trigger="click"
                  popper-class="icon_others_popper">
                  <template #reference>
                    <div class="icon_items">
                      <span :class="['menu-icon', item.icon]"></span>
                      <p>{{item.name}}</p>
                    </div>
                  </template>
                  <div class="popover_list">
                    <div class="item" v-for="(childItem, childIndex) in item.child" :key="childIndex"
                      @click="pushRouter(childItem)">{{childItem.name}}</div>
                  </div>
                </el-popover>
                <div v-else class="icon_items" @click="pushRouter(item)">
                  <span :class="['menu-icon', item.icon]"></span>
                  <p>{{item.name}}</p>
                </div>
              </template>
            </div>
            <div v-else>
              <div class="others" v-for="(item, index) in others" :key="index">
                <div :class="['other_item', {'other_item_cursor': item.path}]" @click="pushRouter(item)">
                  <p><span :class="['menu-icon', item.icon]"></span>{{item.name}}</p>
                </div>
                <div class="other_child" v-if="item.child && item.child.length">
                  <div  
                    v-for="(childItem, childIndex) in item.child" 
                    :key="childIndex"
                    :class="['item', {'active': $route.meta.promission && $route.meta.promission.menuName == childItem.type}]"
                    @click="pushRouter(childItem)">
                    <el-badge v-if="childItem.isDot" :is-dot="childItem.isDot" class="item">{{childItem.name}}</el-badge>
                    <template v-else>{{childItem.name}}</template>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div :class="['menu', {'menu_hidden': !showNav}, {'menu_hidden': noSecond}]">
            <div 
              v-for="(item, index) in nav"
              :key="index"
              :class="['item',{'active': $route.meta.promission && $route.meta.promission.menuName == item.type},menuObj]"
              @click="menuLink(item.path, item.type)">
              {{item.name}}
            </div>
        </div>
        <template v-if="!closeSide">
          <div :class="[classObj,'op_left']" @click.stop="changeLeft">
            <el-icon v-if="!showLeft" :size="14"><ArrowLeft /></el-icon>
            <el-icon v-else :size="14"><ArrowRight /></el-icon>
          </div>
          <div v-if="!noSecond" :class="[classObj,'bottom_left']">
              <p @click.stop="changeAllLeft"><el-icon :size="14"><DArrowLeft /></el-icon>折叠侧边栏</p>
          </div>
        </template>
        <div v-else-if="showMenu && !noSecond" class="bottomShowBtn" @click.stop="changeAllLeft">展开侧边栏<el-icon :size="14"><DArrowRight /></el-icon></div>
      </div>
    </div>
    <el-drawer
      v-model="drawer"
      size="300px"
      :title="`发起的项目 ${proListObj.total}`"
      :direction="direction"
      :before-close="handleClose"
    >
      <div class="drawer-pro-box">
        <template v-for="(item, index) in pro_list" :key="index">
          <el-tooltip
            effect="dark"
            :content="item.title || item.name"
            placement="right">
            <div :class="['drawer-pro-item', {'active': pro_id == item.id}]" @click="changePro(item)">
              <img :src="item.wb_logo_1 || item.logo || 'https://s.moimg.net/m/img/placeholder/default_1x1@2x.png'" />
              <div class="info">
                <p>{{ item.name }}</p>
                <span>{{ item.ctime ? $dayjs(item.ctime).format('YYYY-MM-DD HH:mm') : '' }}</span>
              </div>
            </div>
          </el-tooltip>
        </template>
      </div>
      <template #footer>
        <el-pagination
          class="pagination-box"
          small
          layout="prev, pager, next"
          :total="proListObj.total"
          :hide-on-single-page="true"
          @current-change="change">
        </el-pagination>
      </template>
    </el-drawer>
  </template>
  
  <script>
  import domain from '@/service/domain'
  import { mapState, mapMutations, mapActions } from 'vuex'
  import { getMenu, menuRoute, mapMenu } from '@/utils/mapMenu'
  export default {
    emits: ['scrollTop'],
    props: {
      noSecond: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
          userId: state => state.user.user_id,
          pro_list: state => state.project.proList,
          first_pro_list: state => state.project.firstProList,
          proListObj: state => state.project.proListObj,
          pro_info: state => state.project.proInfo
      }),
      pro_id() {
        return this.$route.params.id || this.$route.query.pro_id | ''
      },
      classObj(){
        return this.showLeft ? 'goLeft' : ''
      },
      coverClassObj(){
        return this.showLeft ? 'coverLeft' : ''
      },
      titleClassObj(){
        return this.showLeft ? 'titleLeft' : ''
      },
      menuObj(){
        return this.closeSide ? 'itemhide' : ''
      },
      nav() {
        if (this.pro_info.info.pro_class == '201') {
          return getMenu('wds')
        } else {
          return getMenu('pro')
        }
      },
      others() {
        return getMenu('others')
      },
      leftFather() {
        return {
          id: this.pro_id,
          list: this.first_pro_list,
          info: this.pro_info.info
        }
      },
      showNav() {
        let proMenu = this.$route.meta.promission ? this.$route.meta.promission.menuName : ''
        return ((this.pro_list && this.pro_list.length) || (this.first_pro_list && this.first_pro_list.length)) && proMenu && mapMenu.proMenu[3].includes(proMenu) && ![-4, 12].includes(this.pro_info.info.status_code)
      },
      showMore() {
        return this.first_pro_list && this.first_pro_list.length > 4
      },
      showMenu() {
        return true
        // if (["17821", "1163384", "1282977", "1569452"].includes(this.userId)) {
        //   return true
        // } else {
        //   return false
        // }
      }
    },
    watch: {
      leftFather: {
        immediate: true,
        handler(n) {
          let leftProList = JSON.parse(sessionStorage.getItem('leftProList') || "[]") || []
          if (this.noSecond && leftProList.length) {
            this.leftProList = leftProList
          }else if (n.list.length && !this.leftChange) {
            let list = n.list
            if (list.length > 4) {
              list = list.slice(0, 4)
            }
            let newlist = []
            list.forEach(item => {
              if (!(item.temp_id ? item.temp_id == this.pro_id : item.id == this.pro_id) 
              ) {
                newlist.push(item)
              }
            })
            if (this.pro_info && this.pro_info.id && JSON.stringify(this.pro_info.info) != '{}') {
              this.leftProList = [this.pro_info.info, ...newlist]
            } else {
              this.leftProList = [...newlist]
            } 
            sessionStorage.setItem('leftProList', JSON.stringify(this.leftProList))
          }
        }
      }
    },
    data() {
      return {
        position:'bottom',
        showLeft: sessionStorage.getItem('showLeft'),
        closeSide: sessionStorage.getItem('closeSide'),
        direction:'rtl',
        drawer:false,
        leftProList: [],
        leftChange: false,
        page: 1
      }
    },
    methods: {
      ...mapActions(["getProList"]),
      ...mapMutations(["updataProInfo", 'updataAuthority']),
      // 折叠左侧
      changeLeft(){
        this.showLeft = !this.showLeft;
        sessionStorage.setItem('showLeft', this.showLeft || '')
      },
      // 折叠整体
      changeAllLeft(){
        this.closeSide = !this.closeSide;
        sessionStorage.setItem('closeSide', this.closeSide || '')
      },
      goIndex() {
        location.href = domain.www
      },
      goLink(path) {
        if (path) {
          window.open(path)
        }
      },
      goInitiate() {
        window.open(`${domain.account}/initiate`)
      },
      goUserInfo() {
        location.href = `${domain.me}/u/user_index`
      },
      pushRouter(item) {
        if(item.methods) {
          item.methods()
          return
        }
        if(item.isDot){
          item.isDot = false;
        }
        if (item.path) {
          if (item.path.indexOf('https://') > -1) {
            window.open(item.path)
          } else {
            this.$router.push(item.path)
          }
        }
      },
      handleClose() {
        this.drawer = false
      },
      // 切换项目
      changePro(item, type) {
        sessionStorage.removeItem('isTemp')
        if (this.drawer) {
          this.drawer = false
        }
        if (type) {
          this.leftChange = true
        } else {
          this.leftChange = false
        }
        if (item.temp_id) {
          this.updataProInfo({
              id: item.temp_id,
              info: item,
          })
          this.updataAuthority(true)
          this.$router.push(`/project_manage/index/temp/${item.temp_id}`)
        } else {
          this.$router.push(`/project_manage/index/${item.id}`)
        }
      },
      // 项目分页
      change(val) {
        this.page = val
        this.getProList(val)
      },
      menuLink(path, type) {
        this.$emit('scrollTop')
        return menuRoute(path, type, this.pro_id, this.pro_info.info)
      }
    }
  }
  </script>
  <style scoped lang="scss">
  .side{
    background: #fff;
    display: flex;
    height: 100%;
    &.closeSide {
      width: 20px;
      background: #F2F2F2;
    }
    .left{
      width: 240px;
      height: calc(100vh - 70px);
      padding-bottom: 20px;
      background: hsl(0, 0%, 100%);
      position: relative;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      .menu-icon {
        font-size: 20px;
        margin-right: 4px;
      }
      &.goLeft{
        width: 76px;
      }
      >.showDrawer{
        margin: 0 auto;
      }
      .showDrawer{
        cursor: pointer;
        width: 51px;
        height: 26px;
        background: rgba(0,196,161,0.08);
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        font-weight: normal;
        color: #00C4A1;
        line-height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        &-bottom {
          margin-top: 10px;
        }
      }
      .title{
        padding: 15px 10px 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &.close {
          padding: 20px 0 0 15px;
          p{
            font-size: 14px;
            line-height: 14px;
          }
        }
        p{
          display: flex;
          align-items: center;
          font-size: 16px;
          font-weight: normal;
          color: #1A1A1A;
          line-height: 16px;
          i{
            padding-right: 7px;
          }
        }
      }
      .project_list{
        padding: 0 10px;
        &.close{
          padding: 0 5px;
        }
        .pro_item{
          padding: 6px 10px;
          margin-top: 9px;
          width: auto;
          background: #fff;
          display: flex;
          align-items: center;
          cursor: pointer;
          border-radius: 6px;
          &:hover{
            background: #F2F2F2;
            .cover{
              border: 2px solid #F2F2F2;
            }
          }
          &.active{
            background: #F2F2F2;
            .cover{
              border: 2px solid #1A1A1A;
            }
            p{
              font-weight: 700;
            }
          }
          .cover{
            width: 60px;
            height: 60px;
            border: 2px solid #fff;
            border-radius: 6px;
            overflow: hidden;
            &.coverLeft{
                width:46px;
                height:46px;
            }
          }
          p{
            margin-left: 10px;
            width: 130px;
            max-height: 48px;
            font-size: 16px;
            font-weight: normal;
            color: #1A1A1A;
            line-height: 24px;
            word-break: break-all;
            &.titleLeft{
              width: 0;
              margin-left: 0;
            }
          }
        }
      }
      .others{
        padding: 0 10px;
        .other_item{
          padding: 25px 0 10px 0;
          &.other_item_cursor{
            cursor: pointer;
          }
          p{
            padding: 0 0 0 10px;
            font-size: 16px;
            font-weight: normal;
            color: #1A1A1A;
            line-height: 16px;
            display: flex;
            align-items: center;
            i{
              padding-right: 7px;
            }
          }
        }
        .other_child{
          display: grid;
          grid-template-columns: repeat(2,1fr);
          .item{
            cursor: pointer;
            padding: 0 0 0 10px;
            width: 109px;
            height: 34px;
            background: #fff;
            font-size: 14px;
            font-family: PingFang SC-中黑体, PingFang SC;
            font-weight: normal;
            color: #7F7F7F;
            line-height: 34px;
            border-radius: 6px;
            &:hover, &.active{
              background: #F2F2F2;
              color: #1A1A1A;
              .el-badge{
                background: #F2F2F2;
                color: #1A1A1A;
              }
            }
            .el-badge{
              padding: 0;
              width: auto;
              ::v-deep .is-dot{
                top: 6px;
              }
            }
          }
        }
      }
      .icon_others{
        padding: 20px 5px 0 5px;
        .icon_items{
          cursor: pointer;
          margin: 10px auto 0;
          padding: 5px 0;
          width: 66px;
          height: 58px;
          background: #fff;
          text-align: center;
          color: #7F7F7F;
          border-radius: 6px;
          .menu-icon {
            font-size: 26px;
            margin-right: 0;
          }
          &:hover{
            background: #F2F2F2;
          }
          i{
            display: block;
            margin: 0 auto;
          }
          p{
            text-align: center;
            padding-top: 6px;
            font-size: 12px;
            font-family: PingFang SC-常规体, PingFang SC;
            font-weight: normal;
            color: #7F7F7F;
            line-height: 12px;
          }
        }
      }
    }
    .menu{
        padding: 10px 10px 60px;
        width: 160px;
        height: 100%;
        background: #F2F2F2;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
        >.item{
          cursor: pointer;
          padding: 10px;
          margin: 10px 0 0 0;
          width: 140px;
          height: 36px;
          font-size: 16px;
          color: #1A1A1A;
          line-height: 16px;
          &.itemhide{
            opacity: 0;
          }
          &.active,&:hover{
            font-weight: 700;
            background: #FFFFFF;
            border-radius: 6px;
          }
        }
        &.menu_hidden {
          width: 20px;
          >div{
            display: none;
          }
        }
    }
  }
  .op_left{
    position: fixed;
    left: 223px;
    bottom: 60px;
    text-align: center;
    line-height: 34px;
    width: 34px;
    height: 34px;
    background: #FFFFFF;
    border-radius: 50%;
    cursor: pointer;
    border: 1px solid #E8E8E8;
    &.goLeft{
      left: 60px;
    }
  }
  .bottom_left{
    background-color: #F2F2F2;
    position: fixed;
    width: 120px;
    font-size: 14px;
    font-weight: normal;
    color: #7F7F7F;
    line-height: 14px;
    left: 260px;
    bottom: 0px;
    &.goLeft{
      left: 96px;
    }
    p{
      cursor: pointer;
      padding: 20px 0;
      display: flex;
      i{
        padding-right: 5px;
      }
      &:nth-child(1){
        border-bottom: 1px solid #E8E8E8;
      }
      &:nth-child(2):hover{
        color: #FF3535;
      }
    }
  }
  .bottomShowBtn{
    position: fixed;
    left: 10px;
    bottom: 10px;
    width: 109px;
    height: 39px;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
    border: 1px solid #E8E8E8;
    font-size: 14px;
    font-family: PingFang SC-细体, PingFang SC;
    font-weight: normal;
    color: #7F7F7F;
    line-height: 39px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1;
    i{
      padding-left: 6px;
    }
  }
  .el-popper {
    .popover_list{
      background: #fff;
      .item{
        width: 110px;
        height: 34px;
        background: #fff;
        cursor: pointer;
        text-indent: 10px;
        font-size: 14px;
        font-weight: normal;
        color: #7F7F7F;
        line-height: 34px;
        border-radius: 6px;
        &:hover{
          background: #F2F2F2;
        }
      }
    }
  }
  .drawer-pro-box {
    height: 100%;
  }
  .drawer-pro-item {
    display: flex;
    width: 280px;
    margin-left: -10px;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 6px;
    overflow: hidden;
    &.active, &:hover {
      background: #F2F2F2;
      img {
        border: 2px solid #1A1A1A;
      }
    }
    img {
      width: 50px;
      height: 50px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .info {
      width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      line-height: 1;
      p {
        font-size: 16px;
        margin-bottom: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        font-size: 12px;
        color: #7F7F7F;
      }
    }
  }
  .pagination-box {
    justify-content: center;
  }
  </style>


<style lang="scss">
.el-popover.el-popper.icon_others_popper {
    padding: 10px;
    min-width: 130px;
}
</style>
  